import React, { useEffect, useState } from "react";
import { RecordAudioPreview } from "./render";

export const RecordAudio = () => {
    const [attrs, setAttrs] = useState({
        vtBackgroundColor: "#FFFFFF",
        vtButtonSize: "20",
        vtIconSize: "10",
    });

    // Cargar parámetros desde VTWidgetBridge
    useEffect(() => {
        const bridge = window?.VTWidgetBridge?.Bridge;
        if (!bridge) {
            console.warn("VTWidgetBridge no disponible. Usando valores por defecto.");
            return;
        }

        bridge
            .getAttributes([
                "vtBackgroundColor",
                "vtButtonSize",
                "vtIconSize",
            ])
            .defaultValues({
                vtBackgroundColor: "#FFFFFF",
                vtButtonSize: "20",
                vtIconSize: "10",
            })
            .then((a) => setAttrs(a));
    }, []);

    const handleAudioRecorded = (base64Audio) => {
        const bridge = window?.VTWidgetBridge?.Bridge;
        if (!bridge) {
            console.log("Audio en Base64 (sin VTWidgetBridge):", base64Audio);
            return;
        }

        // Enviar el audio grabado a Veritran mediante raiseEvent
        bridge.raiseEvent("vtAudioRecorded", {
            vtAudioData: base64Audio,
            vtAudioFormat: "audio/wav",
        });

    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                margin: 0,
                padding: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxSizing: 'border-box',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: attrs.vtBackgroundColor.startsWith("#")
                    ? attrs.vtBackgroundColor
                    : "#" + attrs.vtBackgroundColor
            }}
        >
            <RecordAudioPreview
                onAudioRecorded={handleAudioRecorded}
                buttonSize={attrs.vtButtonSize}
                iconSize={attrs.vtIconSize}
            />
        </div>
    );
};
